export var MfaInfoFailCode;
(function (MfaInfoFailCode) {
    MfaInfoFailCode["SessionFail"] = "MFA_10";
    MfaInfoFailCode["PersistFail"] = "MFA_11";
})(MfaInfoFailCode || (MfaInfoFailCode = {}));
export const MfaInfoSuccessCode = 'MFA_00';
export const MfaInfoErrorCode = 'MFA_99';
export const createMfaSuccessResponse = (response) => response;
export const createMfaFailResponse = (response) => response;
export const createMfaErrorResponse = (response) => response;
export const MfaFailResponse = {
    NEED_TOGGLE_ON: '35',
    NEED_FINANCIAL_PW_AUTH: '36',
};
